import React, { forwardRef, memo } from "react";
import { Chip, Tooltip } from "@mui/material";
import { IEnrStatusChipProps } from "./EnrStatusChip.types";
import {
  ENR_STATUS_CHIP_SIZES,
  resolveVariantStyle,
} from "./EnrStatusChip.constants";

const TOOLTIP_THRESHOLD = 12; // adjust as needed

export const EnrStatusChip = memo(
  forwardRef<HTMLDivElement, IEnrStatusChipProps>(
    ({ content, variant = "WARNING", size = "SM", disabled }, ref) => {
      const styles = resolveVariantStyle(variant);
      const sizeCfg = ENR_STATUS_CHIP_SIZES[size];

      const label = content || "--";
      const showTooltip =
        typeof label === "string" && label.length > TOOLTIP_THRESHOLD;

      const chip = (
        <Chip
          ref={ref}
          size="small"
          label={label}
          disabled={disabled}
          sx={{
            width: sizeCfg.width,
            height: sizeCfg.height,
            fontSize: sizeCfg.fontSize,
            backgroundColor: styles.chipBg,
            border: `1px solid ${styles.chipBorder}`,
            color: styles.text,
            fontWeight: 700,
            borderRadius: 1.2,
            justifyContent: "center",

            "& .MuiChip-label": {
              px: 1,
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },

            "&:hover": {
              backgroundColor: !disabled ? styles.hoverBg : styles.chipBg,
            },

            "&.Mui-disabled": {
              opacity: 0.6,
              cursor: "not-allowed",
            },
          }}
        />
      );

      return showTooltip ? (
        <Tooltip title={label}>
          <span>{chip}</span>
        </Tooltip>
      ) : (
        chip
      );
    },
  ),
);

EnrStatusChip.displayName = "EnrStatusChip";
